import { render, staticRenderFns } from "./ForthLast.vue?vue&type=template&id=126de0a0&"
import script from "./ForthLast.vue?vue&type=script&lang=js&"
export * from "./ForthLast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports